import type { Model } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/asset/model/utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

export const createFields: FormItem<Model>[] = [
  {
    colCount: 2,
    cssClass: 'tmm-section-no-background',
    caption: 'Model Details',
    items: [allFields.tenantId, allFields.name],
  },

  {
    colCount: 2,
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        colCount: 1,
        colSpan: 2,
        items: [allFields.picture],
      },

      {
        colCount: 1,
        colSpan: 2,
        items: [allFields.assetTypeId, allFields.manufacturerId],
      },
    ],
  },

  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 1,
      lg: 1,
    },
    cssClass: 'tmm-section',
    caption: 'Characteristics',
    items: [
      {
        colCount: 1,
        colSpan: 2,
        items: [allFields.specification],
      },
      {
        colCount: 2,
        colSpan: 2,
        items: [allFields.oemPartNumber, allFields.usefulLife],
      },
      {
        colCount: 3,
        colSpan: 3,
        items: [allFields.probability, allFields.severity, allFields.riskScore],
      },
    ],
  },
];

export const updateFields: FormItem<Model>[] = [
  {
    colCount: 2,
    cssClass: 'tmm-section-no-background',
    caption: 'Model Details',
    items: [allFields.tenantId, allFields.name],
  },

  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 4,
      lg: 4,
    },
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        colCount: 1,
        colSpan: 2,
        items: [allFields.picture],
      },

      {
        colCount: 1,
        colSpan: 2,
        items: [allFields.assetTypeId, allFields.manufacturerId, allFields.inUseStatus],
      },
    ],
  },

  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 1,
      lg: 1,
    },
    cssClass: 'tmm-section',
    caption: 'Characteristics',
    items: [
      {
        colCount: 1,
        colSpan: 2,
        items: [allFields.specification],
      },
      {
        colCount: 2,
        colSpan: 2,
        items: [allFields.oemPartNumber, allFields.usefulLife],
      },
      {
        colCount: 3,
        colSpan: 3,
        items: [allFields.probability, allFields.severity, allFields.riskScore],
      },
    ],
  },

  getHistorySection(),
];
